import dayjs from './dayjs';

/**
 * Util derivasi statistik dari raw transaksi.
 *
 * Menggantikan endpoint /statistics: semua angka (per kategori, harian,
 * per dompet, per user) dihitung dari data yang sama dengan daftar
 * transaksi, sehingga Transaksi & Statistik berbagi satu fetch.
 * Format & perilaku dibuat identik dengan respons /statistics:
 * - kategori kosong -> 'Uncategorize'
 * - dompet kosong   -> 'None'
 * - kategori diurutkan amount terbesar -> terkecil
 * - harian diisi 0 untuk tanggal tanpa transaksi (start s/d end inklusif)
 * - per user hanya menghitung transaksi 'kredit'
 */

const UNCATEGORIZE = 'Uncategorize';
const NO_POCKET = 'None';

// Ringkasan kas: total masuk, keluar, saldo
export const hitungSummary = (transc) => {
    let debit = 0;
    let kredit = 0;
    transc.forEach((t) => {
        const amount = parseInt(t.amount) || 0;
        if (t.type === 'debit') {
            debit += amount;
        } else {
            kredit += amount;
        }
    });
    return { debit: debit, kredit: kredit, saldo: debit - kredit };
};

// Statistik lengkap dari raw transaksi
export const deriveStatistik = (transc, start, end) => {
    const category = { debit: {}, kredit: {} };
    const pocket = {};
    const user = {};
    const daily = {};

    // isi semua tanggal di rentang dengan 0 dulu (sesuai perilaku /statistics)
    let cursor = dayjs(start);
    const last = dayjs(end);
    while (cursor.isSameOrBefore(last, 'day')) {
        const key = cursor.format('YYYY-MM-DD');
        daily[key] = { date: key, debit: 0, kredit: 0 };
        // dayjs immutable: add() mengembalikan objek baru -> wajib di-assign
        cursor = cursor.add(1, 'day');
    }

    transc.forEach((t) => {
        const amount = parseInt(t.amount) || 0;
        const type = t.type;

        // per kategori
        const cat = t.category ? t.category : UNCATEGORIZE;
        if (!category[type]) {
            category[type] = {};
        }
        category[type][cat] = (category[type][cat] || 0) + amount;

        // per dompet
        const pkt = t.pocket ? t.pocket : NO_POCKET;
        if (!pocket[pkt]) {
            pocket[pkt] = { pocket: pkt, debit: 0, kredit: 0 };
        }
        pocket[pkt][type] += amount;

        // per user (hanya kredit/pengeluaran, sesuai perilaku /statistics)
        if (type === 'kredit') {
            const name = t.name ? t.name : '?';
            if (!user[name]) {
                user[name] = { name: name, amount: 0, count: 0 };
            }
            user[name].amount += amount;
            user[name].count += 1;
        }

        // harian
        if (daily[t.date]) {
            daily[t.date][type] += amount;
        }
    });

    // ubah map kategori menjadi array {category, amount}, urut terbesar
    const toCategoryList = (map) =>
        Object.keys(map)
            .map((k) => ({ category: k, amount: map[k] }))
            .sort((a, b) => b.amount - a.amount);

    return {
        category: {
            debit: toCategoryList(category.debit),
            kredit: toCategoryList(category.kredit)
        },
        daily: Object.values(daily),
        user: Object.values(user),
        pocket: Object.values(pocket)
    };
};
